export var CardBrand;
(function (CardBrand) {
    CardBrand["UNKNOWN"] = "UNKNOWN";
    CardBrand["VISA"] = "VISA";
    CardBrand["AMERICAN_EXPRESS"] = "AMERICAN_EXPRESS";
    CardBrand["MASTERCARD"] = "MASTERCARD";
    CardBrand["DISCOVER"] = "DISCOVER";
    CardBrand["JCB"] = "JCB";
    CardBrand["DINERS_CLUB"] = "DINERS_CLUB";
    CardBrand["CARTES_BANCAIRES"] = "CARTES_BANCAIRES";
    CardBrand["MAESTRO"] = "MAESTRO";
    CardBrand["DE_BIJENKORF_CARD"] = "DE_BIJENKORF_CARD";
})(CardBrand || (CardBrand = {}));
